import accountsReceivableFullcont from "./accountsReceivable-fullcont.html";

const dialog = require("../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const fullcontReport = require("../../../../../components/fullcont/fullcont-report");
const accountsReceivableDt = require("./accountsReceivable-dt");
const accountsReceivableMenu = require("./accountsReceivable-menu");
const { formCopy } = require("./accountsReceivable-fullcont-form");
const { form } = require("./accountsReceivable-fullcont-form");
const MtGenerator = require("./accountsReceivable-multitable-generator");
const snack = require("../../../../../components/snack/snack");
// const {accountsReceivableMT} = require('./accountsReceivable-fullcont-multitable')
const accountsReceivableMT = undefined; //no MT just add this like undefined
const accountsReceivableFetch = require("./accountsReceivable-fetch");
const accountReceivable = require("./accountsReceivable");
const style = require("../../../../../components/report/report-style");
const css = style.get();

const scrim = require("../../../../../components/scrim/scrim");

let iframe;
let topData = null;
let tableData = null;

/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "accountsReceivable", //database table name****
    "accountsReceivable", //dest entity on js
    "accountsReceivable-fullcont",
    accountsReceivableFullcont,
    form,
    formCopy,
    accountsReceivableMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;
  iframe = document.getElementById("reportIframe");
  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('accountsReceivable-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      accountsReceivableMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(detail, htmlFc);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  callData: {
    start: (detail) => {
      callData(detail, htmlFc);
    },
  },
  // callUnpaidInvoices: {
  //   start: (detail) => {
  //     callUnpaidInvoices(detail, htmlFc);
  //   },
  // },
  click: {
    start: (detail) => {
      click(detail, htmlFc);
    },
  },
  printReport: {
    start: (detail) => {
      printReport(detail, htmlFc);
    },
  },
  printReportOne: {
    start: (detail) => {
      printReportOne(detail, htmlFc);
    },
  },
  saleFullcont2: {
    start: (detail) => {
      saleFullcont2(detail, htmlFc);
    },
  },
}; /**/

function saleFullcont2(detail, htmlFc) {
  accountReceivable.start({
    dest: detail.dest,
    elem: "saleFullcont2",
    id: "sale-fullcont2",
    act: "showFullcont",
    dbid: detail.dbid,
  });
}

//function to send
function editDialog() {
  dialog.start({
    act: "show",
    id: "saveChanges",
    entity: "accountsReceivable",
  });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "accountsReceivable",
    id: "deleteElem",
    entity: "accountsReceivable",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  accountsReceivableDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // accountsReceivableDt.start({"dest":"accountsReceivable", "elem":"dt", "act":"select", "entity":"accountsReceivable"})
  }, 100);
}

function deleteFromDialog(detail, htmlFc) {
  if (parseInt(htmlFc.fullcontHTML.getAttribute("data-DBid")) > 99) {
    fullcontEntity.deleteFromDialog(detail, htmlFc);
    setTimeout(() => {
      accountsReceivableDt.start({
        dest: "accountsReceivable",
        elem: "dt",
        act: "select",
        entity: "accountsReceivable",
      });
    }, 900);
  } else {
    snack.start({ act: "show", id: "accountidisless" });
  }
}

function callData(detail, htmlFc) {
  const container = document.getElementById("multitable-report-receivable");

  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivableAll",
    dbid: detail.dbid,
  };

  accountsReceivableFetch.fetchOne(fetchDetail, (data) => {
    fullcontReport.showFullcont(detail, data, {
      id: "#accountsReceivable_form_",
      fields: [
        "customer",
        "current",
        "total_due",
        "total_due_30_days",
        "total_due_31_to_60_days",
        "total_due_61_to_90_days",
        "total_due_over_90_days",
      ],
    });

    const tablesData = JSON.parse(data[0].multiTables);

    fullcontReport.renderUnpaidInvoices(tablesData, {
      container: container,
      lineRenderer: MtGenerator.unpaid_invoices_list,
      headerHtml: `
        <div class="o54">
          <div class="row">
            <div class="c20"><label class="font-caption label-report">Date</label></div>
            <div class="c20"><label class="font-caption label-report">Code</label></div>
            <div class="c20"><label class="font-caption label-report">Due Date</label></div>
            <div class="c20"><label class="font-caption label-report">Original Amount</label></div>
            <div class="c20"><label class="font-caption label-report">Due Amount</label></div>
          </div>
        </div>
      `,
      afterLineRender: (line, item) => {
        fullcontReport.autoAssignValuesByClass(line, item);
      },
    });

    topData = data;
    tableData = tablesData;
  });
}

function printReport(detail, htmlFc) {
  if (detail.dbid) {
    generateReport(detail.dbid, detail.entity, detail.reportName);
    return
  }

  const cont = htmlFc.fullcontHTML;
  const id = cont.getAttribute('data-dbid') || null;
  generateReport(id, detail.entity, detail.reportName);
  return

}

function generateReport(dbid, entity, reportName) {
  scrim.showLoading()
  const formData = new FormData();
  formData.append('id', dbid);
  formData.append('type', 'print');
  formData.append('entity', entity);
  formData.append('reportName', reportName);

  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/report/report-pdf.php`, options)
    .then((response) => {
      clearTimeout(timeout);
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          scrim.hideLoading()
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        scrim.hideLoading()
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })

    .catch(error => {
      scrim.hideLoading()
      throw error;
    });
}